import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ForgotPasswordService } from '../forgot-password.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login.service';
import * as myGlobal from 'global';

@Component( {
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css']
} )
export class ForgotPasswordComponent implements OnInit {
    forgotPassForm: FormGroup;
    errMsg: string;
    submitted = false;
    isemailnameReq = false;
    EMAIL_ERR_REQ;
    email_id;

    forgotClass = {
        'email_id': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ]
    };
    isInvalid = false;
    statusObj: any;
    verifyUser = new FormGroup( {
        userN: new FormControl( '', [Validators.required] ),
        OTP: new FormControl( '', [Validators.required] ),
    } );
    resetPasswordForm = new FormGroup( {
        verificationCode: new FormControl( '', [Validators.required] ),
        newpassword: new FormControl( '', [Validators.required] )
    } );
    resetClass = {

        'verificationCode': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ],
        'newpassword': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ]
    };
    isverificationReq = false;
    verify_err_req;
    isnewpasswordReq = false;
    newpassword_err_req;
    reset_pass_msg;
    isreset = false;
    isresetErr = false;
    userNReq;
    OTPReq;
    userNVer = false;
    userNErrVer = false;
    user_ver_msg;
    otp_err_req;
    sub;

    constructor( private forgotPasswordService: ForgotPasswordService, private route: ActivatedRoute,
                 private router: Router, private loginService: LoginService ) {
    }

    ngOnInit() {
        this.forgotPassForm = new FormGroup( {
            email_id: new FormControl( '', [Validators.required] )
        } );
    }

    onEnterEmail() {
        if ( this.forgotPassForm.get( 'email_id' ).valid ) {
            this.isInvalid = false;
            this.isemailnameReq = false;
            this.forgotClass[ 'email_id' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false}
            ];
        } else if ( this.forgotPassForm.get( 'email_id' ).hasError( 'required' ) ) {
            this.isInvalid = true;
            this.isemailnameReq = true;
            this.EMAIL_ERR_REQ = myGlobal.EMAIL_ERR_REQ;
            this.forgotClass[ 'email_id' ] = [
                {'success-validate': false, 'error-validate': true},
                {'icon-work-done': false, 'icon-close-border': true}
            ];
        }

    }

    forgotPassword() {
        this.errMsg = '';

        const postJson = {'email_id': this.forgotPassForm.value.email_id};
        this.email_id = postJson.email_id;
        const myJson = JSON.stringify( postJson );
        this.forgotPasswordService.forgotPassword( postJson ).subscribe( post => {
                // if (post.status === 200) {
                //   this.router.navigate(['reset-password']);
                // }
                document.getElementById( 'reset-pass-btn' ).click();
            }
            , error => {
                this.errMsg = error.error.error_msg;
            } );

    }

    onEnterVerification() {
        if ( this.resetPasswordForm.get( 'verificationCode' ).valid ) {
            this.isverificationReq = false;
            this.resetClass[ 'verificationCode' ] = [
                {'success-validate': true, 'error-validate': false},

            ];
        } else if ( this.resetPasswordForm.get( 'verificationCode' ).hasError( 'required' ) ) {
            this.isverificationReq = true;
            this.verify_err_req = myGlobal.VERIFY_ERR_REQ;
            this.resetClass[ 'verificationCode' ] = [
                {'success-validate': false, 'error-validate': true},
            ];
        }
    }

    onEnterNewPassword() {
        if ( this.resetPasswordForm.get( 'newpassword' ).valid ) {
            this.isnewpasswordReq = false;
            this.resetClass[ 'newpassword' ] = [
                {'success-validate': true, 'error-validate': false},
            ];
        } else if ( this.resetPasswordForm.get( 'newpassword' ).hasError( 'required' ) ) {
            this.isnewpasswordReq = true;
            this.newpassword_err_req = myGlobal.PASSWORD_ERR_REQ;
            this.resetClass[ 'newpassword' ] = [
                {'success-validate': false, 'error-validate': true},
            ];
        }
    }

    clearResetForm() {
        this.resetPasswordForm.reset();
        this.isresetErr = false;
        this.isreset = false;
    }

    resetPassword() {
        const resetpassobj = {
            'email_id': this.email_id, // this.resetPasswordForm.get('emailId').value,
            'verification_code': this.resetPasswordForm.get( 'verificationCode' ).value,
            'new_password': this.resetPasswordForm.get( 'newpassword' ).value
        };
        if ( this.resetPasswordForm.valid ) {
            if ( this.sub ) {
                this.sub.unsubscribe();
            }
            this.sub = this.loginService.postResetPassword( resetpassobj )
                .subscribe( post => {
                    this.isresetErr = false;
                    this.isreset = true;
                    console.log( 'post', post );
                    // this.reset_pass_msg = "success"
                    // this.resetPasswordForm.reset();
                    document.getElementById( 'reset-password-close' ).click();
                    // if (post.status === "success") {
                    this.router.navigate( ['reset-password'] );
                    // }
                }, error => {
                    this.isresetErr = true;
                    this.isreset = false;
                    this.reset_pass_msg = error.error.error_msg;
                    this.resetPasswordForm.reset();
                } );
        }
    }

    onSubmit() {
        this.submitted = true;
        if ( this.forgotPassForm.invalid ) {
            return;
        }
    }
}
